import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface AdminContextType {
  isAdmin: boolean;
  login: (username: string, password: string) => boolean;
  logout: () => void;
}

const AdminContext = createContext<AdminContextType | undefined>(undefined);

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
};

interface AdminProviderProps {
  children: ReactNode;
}

export const AdminProvider: React.FC<AdminProviderProps> = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);

  // Check for existing admin session on mount
  useEffect(() => {
    const adminSession = localStorage.getItem('adminSession');
    if (adminSession) {
      const sessionData = JSON.parse(adminSession);
      const now = Date.now();
      // Session expires after 24 hours
      if (now - sessionData.timestamp < 24 * 60 * 60 * 1000) {
        setIsAdmin(true);
      } else {
        localStorage.removeItem('adminSession');
      }
    }
  }, []);

  const login = (username: string, password: string): boolean => {
    if (username === 'techcosmocrat' && password === 'clifforD@1') {
      setIsAdmin(true);
      localStorage.setItem('adminSession', JSON.stringify({
        timestamp: Date.now()
      }));
      return true;
    }
    return false;
  };

  const logout = () => {
    setIsAdmin(false);
    localStorage.removeItem('adminSession');
  };

  const value: AdminContextType = {
    isAdmin,
    login,
    logout
  };

  return (
    <AdminContext.Provider value={value}>
      {children}
    </AdminContext.Provider>
  );
}; 